var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { property, query } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { isNil, isNumber, toNumber } from 'lodash-es';
import { sdsCustomElement } from '../utilities/custom-components';
import { SdsNumberInputBase } from './_sds-number-input-base';
import { appendZeros, cutValueToPrecision, removeLastDecimalPoint, shouldHandlePrecision, } from './precision-calculations';
import styles from './sds-number-input.lit.scss';
import { Big } from 'big.js';
/**
 * Numeric input with configurable min/max, step, precision, and optional stepper buttons.
 * Extends `SdsNumberInputBase` — inherits `value`, `disabled`, `invalid`, `placeholder`, etc.
 * Auto-validates against `min`/`max` and sets `invalid`/`errorMessage` automatically.
 *
 * @tag sds-number-input
 */
let SdsNumberInput = (() => {
    var _SdsNumberInput_rightAligned_accessor_storage, _SdsNumberInput_integerOnly_accessor_storage, _SdsNumberInput_padDecimalZeros_accessor_storage, _SdsNumberInput_decimalSeparator_accessor_storage, _SdsNumberInput_thousandsSeparator_accessor_storage, _SdsNumberInput_min_accessor_storage, _SdsNumberInput_max_accessor_storage, _SdsNumberInput_step_accessor_storage, _SdsNumberInput_stepper_accessor_storage, _SdsNumberInput_precision_accessor_storage, _SdsNumberInput_maxDigitCount_accessor_storage, _SdsNumberInput__input_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-number-input')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsNumberInputBase;
    let _instanceExtraInitializers = [];
    let _rightAligned_decorators;
    let _rightAligned_initializers = [];
    let _rightAligned_extraInitializers = [];
    let _integerOnly_decorators;
    let _integerOnly_initializers = [];
    let _integerOnly_extraInitializers = [];
    let _padDecimalZeros_decorators;
    let _padDecimalZeros_initializers = [];
    let _padDecimalZeros_extraInitializers = [];
    let _decimalSeparator_decorators;
    let _decimalSeparator_initializers = [];
    let _decimalSeparator_extraInitializers = [];
    let _thousandsSeparator_decorators;
    let _thousandsSeparator_initializers = [];
    let _thousandsSeparator_extraInitializers = [];
    let _min_decorators;
    let _min_initializers = [];
    let _min_extraInitializers = [];
    let _max_decorators;
    let _max_initializers = [];
    let _max_extraInitializers = [];
    let _step_decorators;
    let _step_initializers = [];
    let _step_extraInitializers = [];
    let _stepper_decorators;
    let _stepper_initializers = [];
    let _stepper_extraInitializers = [];
    let _precision_decorators;
    let _precision_initializers = [];
    let _precision_extraInitializers = [];
    let _maxDigitCount_decorators;
    let _maxDigitCount_initializers = [];
    let _maxDigitCount_extraInitializers = [];
    let __input_decorators;
    let __input_initializers = [];
    let __input_extraInitializers = [];
    let _set_disabledIncrease_decorators;
    let _set_disabledDecrease_decorators;
    var SdsNumberInput = _classThis = class extends _classSuper {
        constructor() {
            var _a, _b;
            super();
            this._lastWheelStepAt = (__runInitializers(this, _instanceExtraInitializers), 0);
            this._autoRangeMessage = '';
            this._focusFromPointer = false;
            this._onPointerDown = () => {
                this._focusFromPointer = true;
            };
            _SdsNumberInput_rightAligned_accessor_storage.set(this, __runInitializers(this, _rightAligned_initializers, void 0));
            _SdsNumberInput_integerOnly_accessor_storage.set(this, (__runInitializers(this, _rightAligned_extraInitializers), __runInitializers(this, _integerOnly_initializers, false)));
            _SdsNumberInput_padDecimalZeros_accessor_storage.set(this, (__runInitializers(this, _integerOnly_extraInitializers), __runInitializers(this, _padDecimalZeros_initializers, false)));
            _SdsNumberInput_decimalSeparator_accessor_storage.set(this, (__runInitializers(this, _padDecimalZeros_extraInitializers), __runInitializers(this, _decimalSeparator_initializers, (_a = new Intl.NumberFormat().format(1.1).replace(/\d/g, '')[0]) !== null && _a !== void 0 ? _a : '')));
            _SdsNumberInput_thousandsSeparator_accessor_storage.set(this, (__runInitializers(this, _decimalSeparator_extraInitializers), __runInitializers(this, _thousandsSeparator_initializers, (_b = new Intl.NumberFormat().format(1111).replace(/\d/g, '')[0]) !== null && _b !== void 0 ? _b : '')));
            _SdsNumberInput_min_accessor_storage.set(this, (__runInitializers(this, _thousandsSeparator_extraInitializers), __runInitializers(this, _min_initializers, void 0)));
            _SdsNumberInput_max_accessor_storage.set(this, (__runInitializers(this, _min_extraInitializers), __runInitializers(this, _max_initializers, void 0)));
            _SdsNumberInput_step_accessor_storage.set(this, (__runInitializers(this, _max_extraInitializers), __runInitializers(this, _step_initializers, 1)));
            _SdsNumberInput_stepper_accessor_storage.set(this, (__runInitializers(this, _step_extraInitializers), __runInitializers(this, _stepper_initializers, false)));
            _SdsNumberInput_precision_accessor_storage.set(this, (__runInitializers(this, _stepper_extraInitializers), __runInitializers(this, _precision_initializers, 3)));
            _SdsNumberInput_maxDigitCount_accessor_storage.set(this, (__runInitializers(this, _precision_extraInitializers), __runInitializers(this, _maxDigitCount_initializers, void 0)));
            _SdsNumberInput__input_accessor_storage.set(this, (__runInitializers(this, _maxDigitCount_extraInitializers), __runInitializers(this, __input_initializers, void 0)));
            this._disabledDecrease = __runInitializers(this, __input_extraInitializers);
            this._shouldUpdateInput = false;
            // For numeric inputs we default to no clear button.
            // Users can explicitly enable it via `has-clear="true"`.
            this.hasClear = false;
            this.isNumberInput = true;
        }
        getInputRootClassInfo() {
            return Object.assign(Object.assign({}, super.getInputRootClassInfo()), { 'sds-input--right-aligned': this.rightAligned });
        }
        /**
         * Right-aligns the text content of the input field.
         *
         * @attr {boolean} right-aligned
         */
        get rightAligned() { return __classPrivateFieldGet(this, _SdsNumberInput_rightAligned_accessor_storage, "f"); }
        set rightAligned(value) { __classPrivateFieldSet(this, _SdsNumberInput_rightAligned_accessor_storage, value, "f"); }
        /**
         * Indicates whether the input should accept only integer numbers.
         * When set to `true`, the input allows only integer values.
         */
        get integerOnly() { return __classPrivateFieldGet(this, _SdsNumberInput_integerOnly_accessor_storage, "f"); }
        set integerOnly(value) { __classPrivateFieldSet(this, _SdsNumberInput_integerOnly_accessor_storage, value, "f"); }
        /**
         * Specifies the `padDecimalZeros` behavior for the input.
         * Accepts true to enable and false to disable browser padDecimalZeros.
         */
        get padDecimalZeros() { return __classPrivateFieldGet(this, _SdsNumberInput_padDecimalZeros_accessor_storage, "f"); }
        set padDecimalZeros(value) { __classPrivateFieldSet(this, _SdsNumberInput_padDecimalZeros_accessor_storage, value, "f"); }
        /**
         * Defines the character used as the decimal separator in numeric input.
         * Accepts either `'.'` or `','` depending on localization.
         */
        get decimalSeparator() { return __classPrivateFieldGet(this, _SdsNumberInput_decimalSeparator_accessor_storage, "f"); }
        set decimalSeparator(value) { __classPrivateFieldSet(this, _SdsNumberInput_decimalSeparator_accessor_storage, value, "f"); }
        /**
         * Defines the character used as the thousands separator in numeric input.
         * Useful for formatting large numbers. Common values include `'.'`, `','`, space `' '`, or an empty string `''`.
         */
        get thousandsSeparator() { return __classPrivateFieldGet(this, _SdsNumberInput_thousandsSeparator_accessor_storage, "f"); }
        set thousandsSeparator(value) { __classPrivateFieldSet(this, _SdsNumberInput_thousandsSeparator_accessor_storage, value, "f"); }
        /**
         * Minimum value for this input.
         * This property defines the lowest numeric value that can be entered.
         *
         * @attr {number} min - The minimum allowable value.
         */
        get min() { return __classPrivateFieldGet(this, _SdsNumberInput_min_accessor_storage, "f"); }
        set min(value) { __classPrivateFieldSet(this, _SdsNumberInput_min_accessor_storage, value, "f"); }
        /**
         * Maximum value for this input.
         * This property defines the highest numeric value that can be entered.
         *
         * @attr {number} max - The maximum allowable value.
         */
        get max() { return __classPrivateFieldGet(this, _SdsNumberInput_max_accessor_storage, "f"); }
        set max(value) { __classPrivateFieldSet(this, _SdsNumberInput_max_accessor_storage, value, "f"); }
        /**
         * Step by which the value of this input increases.
         * This property sets the increment value to apply when adjusting the number.
         *
         * Defaults to `1`.
         *
         * @attr {number} step - The increment step value.
         */
        get step() { return __classPrivateFieldGet(this, _SdsNumberInput_step_accessor_storage, "f"); }
        set step(value) { __classPrivateFieldSet(this, _SdsNumberInput_step_accessor_storage, value, "f"); }
        /**
         * Shows increment and decrement stepper buttons alongside the input.
         *
         * @attr {boolean} stepper
         */
        get stepper() { return __classPrivateFieldGet(this, _SdsNumberInput_stepper_accessor_storage, "f"); }
        set stepper(value) { __classPrivateFieldSet(this, _SdsNumberInput_stepper_accessor_storage, value, "f"); }
        /**
         * Number of decimal places for the input value.
         * This property specifies the precision of the numeric value.
         *
         * @attr {number} precision - The number of decimal places.
         */
        get precision() { return __classPrivateFieldGet(this, _SdsNumberInput_precision_accessor_storage, "f"); }
        set precision(value) { __classPrivateFieldSet(this, _SdsNumberInput_precision_accessor_storage, value, "f"); }
        /**
         * Maximum number of integer digits allowed in the input.
         * Input is truncated once this limit is reached.
         *
         * @attr {number} max-digit-count
         */
        get maxDigitCount() { return __classPrivateFieldGet(this, _SdsNumberInput_maxDigitCount_accessor_storage, "f"); }
        set maxDigitCount(value) { __classPrivateFieldSet(this, _SdsNumberInput_maxDigitCount_accessor_storage, value, "f"); }
        get _input() { return __classPrivateFieldGet(this, _SdsNumberInput__input_accessor_storage, "f"); }
        set _input(value) { __classPrivateFieldSet(this, _SdsNumberInput__input_accessor_storage, value, "f"); }
        get disabledIncrease() {
            return this.parseStringToNumber(this.value) === this.max || this.disabled;
        }
        /**
         * True if the increase button is disabled.
         * This attribute disables the increase control, preventing further increments.
         *
         * @attr {boolean} disabled-increase - Disables the increase button.
         */
        set disabledIncrease(value) {
            const oldValue = this._disabledIncrease;
            this._disabledIncrease = value;
            this.requestUpdate('disabledIncrease', oldValue);
        }
        get disabledDecrease() {
            return this.parseStringToNumber(this.value) === this.min || this.disabled;
        }
        /**
         * True if the decrease button is disabled.
         * This attribute disables the decrease control, preventing further decrements.
         *
         * @attr {boolean} disabled-decrease - Disables the decrease button.
         */
        set disabledDecrease(value) {
            const oldValue = this._disabledDecrease;
            this._disabledDecrease = value;
            this.requestUpdate('disabledDecrease', oldValue);
        }
        updated(changedProperties) {
            if (changedProperties.has('focused') && this.focused) {
                this.getInput().focus();
            }
            if (isNil(this.value)) {
                this.value = '';
            }
            const inputValue = this.parseStringToNumber(this.value);
            if (isNumber(inputValue)) {
                this.getInput().value = this.value.toString();
            }
            if (changedProperties.has('value') ||
                changedProperties.has('min') ||
                changedProperties.has('max')) {
                this.syncRangeValidation();
            }
        }
        render() {
            return html `
            <div class="${this.getClasses()} sds-input--number">
                <div class="sds-input__wrapper">
                    ${this.renderInput('text')} ${this.renderStepper()}
                    ${this.renderActionContainer()}
                </div>
                ${this.renderMessages()}
            </div>
        `;
        }
        renderStepper() {
            if (this.stepper) {
                return html `
                <button
                    type="button"
                    class="${this.getIncreaseClasses()}"
                    @click="${() => this.handleIncreaseOrDecrease('increase')}"
                    ?disabled="${this.disabledIncrease}"
                    aria-hidden="true"
                    tabindex="-1"
                >
                    <sds-icon library="system" name="arrow_up_small" size="16"></sds-icon>
                </button>

                <button
                    type="button"
                    class="${this.getDecreaseClasses()}"
                    @click="${() => this.handleIncreaseOrDecrease('decrease')}"
                    ?disabled="${this.disabledDecrease}"
                    aria-hidden="true"
                    tabindex="-1"
                >
                    <sds-icon library="system" name="arrow_down_small" size="16"></sds-icon>
                </button>
            `;
            }
        }
        async firstUpdated(_changedProperties) {
            await this.updateComplete;
            super.firstUpdated(_changedProperties);
            this.getInput().addEventListener('pointerdown', this._onPointerDown);
            if (_changedProperties.has('value')) {
                if (isNil(this.value)) {
                    this.value = '';
                }
                this.value = this.value.toString().replace('.', this.decimalSeparator);
                this.removeZerosFromStart();
                this.setAttribute('value', this.appendPrecisionZeros());
                this.requestUpdate('value');
                this._shouldUpdateInput = true;
            }
        }
        willUpdate(_changedProperties) {
            super.willUpdate(_changedProperties);
            if (_changedProperties.has('value')) {
                if (isNil(this.value)) {
                    this.value = '';
                }
                if (this._shouldUpdateInput) {
                    this.value = this.value.toString().replace('.', this.decimalSeparator);
                    this.updateInputOnAttributeChange();
                }
                else {
                    this._shouldUpdateInput = true;
                }
            }
        }
        getInput() {
            return this._input;
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.getInput().removeEventListener('pointerdown', this._onPointerDown);
        }
        getAriaValueNow() {
            const value = this.getDispatchedValue();
            return value === '' ? undefined : value.toString();
        }
        getAriaValueMin() {
            return isNumber(this.min) ? this.min.toString() : undefined;
        }
        getAriaValueMax() {
            return isNumber(this.max) ? this.max.toString() : undefined;
        }
        handleWheel(event) {
            // Only change value via wheel when focused.
            if (!this.focused || !this.step)
                return;
            // Only intercept wheel when the pointer is over the input element itself.
            const input = this.getInput();
            const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
            if (!path.includes(input))
                return;
            // Prevent page scroll while interacting with the focused input, even if throttled.
            event.preventDefault();
            const now = performance.now();
            const STEP_THROTTLE_MS = 120;
            if (now - this._lastWheelStepAt < STEP_THROTTLE_MS)
                return;
            this._lastWheelStepAt = now;
            this.handleIncreaseOrDecrease(event.deltaY < 0 ? 'increase' : 'decrease');
        }
        handleKeyDown(event) {
            if (this.disabled || this.readonly) {
                return;
            }
            if (event.key === 'ArrowUp') {
                event.preventDefault();
                this.handleIncreaseOrDecrease('increase');
            }
            else if (event.key === 'ArrowDown') {
                event.preventDefault();
                this.handleIncreaseOrDecrease('decrease');
            }
        }
        handleInput() {
            this.value = this.convertValue(this.getInput().value, true);
            this.dispatchCustomEvent(SdsNumberInput.INPUT_EVENT);
        }
        handleChanged() {
            this.removeZerosFromStart();
            const inputValue = this.parseStringToNumber(this.value);
            if (isNumber(inputValue)) {
                this.value = this.clampWithinMinMax(Number(inputValue));
                this.getInput().value = this.value.toString();
            }
            this.value = this.convertValue(this.getInput().value);
            this.syncRangeValidation();
            this.dispatchCustomEvent(SdsNumberInputBase.CHANGE_EVENT);
            this.dispatchCustomEvent(SdsNumberInput.NATIVE_INPUT_EVENT);
            this.dispatchCustomEvent(SdsNumberInputBase.INPUT_EVENT);
        }
        handleFocus() {
            super.handleFocus();
            this.value = this.convertValue(this.getInput().value, true);
            void this.updateComplete.then(() => {
                var _a;
                if (this._focusFromPointer) {
                    this._focusFromPointer = false;
                    return;
                }
                (_a = this.getInput()) === null || _a === void 0 ? void 0 : _a.select();
            });
        }
        handleBlur() {
            super.handleBlur();
            this._focusFromPointer = false;
            this.handleChanged();
        }
        getDispatchedValue() {
            const parsedValue = this.parseStringToNumber(this.value);
            return isNaN(parsedValue) ? '' : parsedValue;
        }
        dispatchCustomEvent(event) {
            this.dispatchEvent(new CustomEvent(event, {
                detail: { value: this.getDispatchedValue() },
                bubbles: false,
                composed: false,
            }));
        }
        convertValue(value, isSanitize = false) {
            this._shouldUpdateInput = false;
            const sanitized = isSanitize
                ? this.sanitizeDecimalInput(value)
                : this.parseToLocaleString(value);
            const modifiedValue = this.handlePrecision(sanitized, this.decimalSeparator);
            if (modifiedValue !== value) {
                this.getInput().value = modifiedValue;
                value = modifiedValue;
            }
            this.requestUpdate('value');
            return value;
        }
        sanitizeDecimalInput(value) {
            let sanitizedValue = value.trim();
            sanitizedValue = this.removeThousandsSeparator(sanitizedValue);
            let result = '';
            let hasDot = false;
            let digitCount = 0;
            for (let i = 0; i < sanitizedValue.length; i++) {
                const char = sanitizedValue[i];
                const isDigit = char >= '0' && char <= '9';
                const isLeadingSign = i === 0 && this.isAllowedLeadingSign(char);
                const isValidDot = !this.integerOnly && char === this.decimalSeparator && !hasDot;
                if (isLeadingSign) {
                    result += char;
                }
                else if (isDigit) {
                    if (!isNil(this.maxDigitCount) && digitCount >= this.maxDigitCount) {
                        break;
                    }
                    result += char;
                    digitCount++;
                }
                else if (isValidDot) {
                    result += this.decimalSeparator;
                    hasDot = true;
                }
                else {
                    break;
                }
            }
            return result;
        }
        parseToLocaleString(value) {
            if (!value || isNaN(parseFloat(value)))
                return '';
            if (!this.thousandsSeparator)
                return value;
            if (value.startsWith(this.decimalSeparator)) {
                value = '0' + value;
            }
            else if (value.startsWith(`-${this.decimalSeparator}`)) {
                value = '-0' + value.substring(1);
            }
            const bigValue = value.toLowerCase().indexOf('e') > 0 ? Big(value).toFixed() : value;
            const [integerPart, decimalPart] = bigValue.split(this.decimalSeparator);
            let formatted = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
            if (bigValue.indexOf(this.decimalSeparator) > 0 &&
                !bigValue.endsWith(this.decimalSeparator)) {
                formatted += this.decimalSeparator;
            }
            if (decimalPart !== undefined) {
                formatted += decimalPart;
            }
            return formatted;
        }
        isAllowedLeadingSign(char) {
            if (char === '-')
                return this.min === undefined || this.min < 0;
            return false;
        }
        parseStringToNumber(value, isRemoveThousandsSeparator = true) {
            value = isNil(value) ? '' : value.toString();
            let numberValue = value;
            if (isRemoveThousandsSeparator) {
                numberValue = this.removeThousandsSeparator(numberValue);
            }
            numberValue = numberValue.replace(this.decimalSeparator, '.');
            return parseFloat(numberValue);
        }
        removeThousandsSeparator(value) {
            return value.replaceAll(this.thousandsSeparator, '');
        }
        emptyValue() {
            return '';
        }
        clampWithinMinMax(value) {
            if (!!this.min && value < this.min) {
                return Big(this.min).toFixed();
            }
            if (!!this.max && value > this.max) {
                return Big(this.max).toFixed();
            }
            return this.value.toString();
        }
        syncRangeValidation() {
            if (this.hasAttribute('invalid') && !this._autoRangeMessage) {
                return;
            }
            const parsedValue = this.parseStringToNumber(this.value);
            const hasNumericValue = !isNaN(parsedValue);
            const hasMin = isNumber(this.min);
            const hasMax = isNumber(this.max);
            const outOfRange = hasNumericValue &&
                ((hasMin && parsedValue < this.min) || (hasMax && parsedValue > this.max));
            this.invalid = outOfRange;
            if (outOfRange) {
                let message = '';
                if (hasMin && hasMax) {
                    message = `Value must be between ${this.min} and ${this.max}.`;
                }
                else if (hasMin) {
                    message = `Value must be greater than or equal to ${this.min}.`;
                }
                else if (hasMax) {
                    message = `Value must be less than or equal to ${this.max}.`;
                }
                if (!this.errorMessage || this.errorMessage === this._autoRangeMessage) {
                    this.errorMessage = message;
                    this._autoRangeMessage = message;
                }
                return;
            }
            if (this.errorMessage === this._autoRangeMessage) {
                this.errorMessage = '';
                this._autoRangeMessage = '';
            }
        }
        appendPrecisionZeros() {
            if (this.padDecimalZeros &&
                !isNil(this.precision) &&
                this.precision > 0 &&
                toNumber(this.value) !== 0) {
                return appendZeros(this.value.toString(), this.decimalSeparator, this.precision);
            }
            return this.value.toString();
        }
        removeZerosFromStart() {
            var _a;
            let value = (_a = this.getInput()) === null || _a === void 0 ? void 0 : _a.value;
            if (!value || value === '0' || value === `0${this.decimalSeparator}` || value === '-')
                return;
            const cleaned = value.replace(/^(-?)0+(?=\d)/, '$1');
            if (cleaned !== value) {
                value = cleaned;
                this.value = this.parseStringToNumber(cleaned, false) || '';
            }
        }
        updateInputOnAttributeChange() {
            const modifiedValue = this.parseToLocaleString(removeLastDecimalPoint(this.handlePrecision(this.value.toString(), this.decimalSeparator), this.decimalSeparator));
            this.getInput().value = modifiedValue;
            this.value = modifiedValue;
        }
        handlePrecision(value, decimalSeparator) {
            return shouldHandlePrecision(value, decimalSeparator, this.precision)
                ? cutValueToPrecision(value, decimalSeparator, this.precision)
                : value;
        }
        handleIncreaseOrDecrease(direction) {
            const val = this.parseStringToNumber(this.value) || '';
            const stepValue = direction === 'increase' ? this.step : -this.step;
            this.value = (Number(val) + stepValue).toString();
            this.value = this.clampWithinMinMax(Number(this.value));
            this.removeZerosFromStart();
            this.dispatchCustomEvent(SdsNumberInput.INPUT_EVENT);
            this.dispatchCustomEvent(SdsNumberInputBase.ACTION_EVENT);
            this.dispatchCustomEvent(SdsNumberInputBase.CHANGE_EVENT);
        }
        getIncreaseClasses() {
            return classMap({
                'sds-input__control': true,
                'sds-input__control--increase': true,
                'sds-input__control--disabled': this.disabledIncrease,
            });
        }
        getDecreaseClasses() {
            return classMap({
                'sds-input__control': true,
                'sds-input__control--decrease': true,
                'sds-input__control--disabled': this.disabledDecrease,
            });
        }
    };
    _SdsNumberInput_rightAligned_accessor_storage = new WeakMap();
    _SdsNumberInput_integerOnly_accessor_storage = new WeakMap();
    _SdsNumberInput_padDecimalZeros_accessor_storage = new WeakMap();
    _SdsNumberInput_decimalSeparator_accessor_storage = new WeakMap();
    _SdsNumberInput_thousandsSeparator_accessor_storage = new WeakMap();
    _SdsNumberInput_min_accessor_storage = new WeakMap();
    _SdsNumberInput_max_accessor_storage = new WeakMap();
    _SdsNumberInput_step_accessor_storage = new WeakMap();
    _SdsNumberInput_stepper_accessor_storage = new WeakMap();
    _SdsNumberInput_precision_accessor_storage = new WeakMap();
    _SdsNumberInput_maxDigitCount_accessor_storage = new WeakMap();
    _SdsNumberInput__input_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsNumberInput");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _rightAligned_decorators = [property({ type: Boolean, attribute: 'right-aligned' })];
        _integerOnly_decorators = [property({ type: Boolean, attribute: 'integer-only' })];
        _padDecimalZeros_decorators = [property({ type: Boolean, attribute: 'pad-decimal-zeros' })];
        _decimalSeparator_decorators = [property({ type: String, attribute: 'decimal-separator' })];
        _thousandsSeparator_decorators = [property({ type: String, attribute: 'thousands-separator' })];
        _min_decorators = [property({ type: Number })];
        _max_decorators = [property({ type: Number })];
        _step_decorators = [property({ type: Number })];
        _stepper_decorators = [property({ type: Boolean })];
        _precision_decorators = [property({ type: Number })];
        _maxDigitCount_decorators = [property({ type: Number, attribute: 'max-digit-count' })];
        __input_decorators = [query('input.sds-input__element')];
        _set_disabledIncrease_decorators = [property({ type: Boolean, attribute: 'disabled-increase' })];
        _set_disabledDecrease_decorators = [property({ type: Boolean, attribute: 'disabled-decrease' })];
        __esDecorate(_classThis, null, _rightAligned_decorators, { kind: "accessor", name: "rightAligned", static: false, private: false, access: { has: obj => "rightAligned" in obj, get: obj => obj.rightAligned, set: (obj, value) => { obj.rightAligned = value; } }, metadata: _metadata }, _rightAligned_initializers, _rightAligned_extraInitializers);
        __esDecorate(_classThis, null, _integerOnly_decorators, { kind: "accessor", name: "integerOnly", static: false, private: false, access: { has: obj => "integerOnly" in obj, get: obj => obj.integerOnly, set: (obj, value) => { obj.integerOnly = value; } }, metadata: _metadata }, _integerOnly_initializers, _integerOnly_extraInitializers);
        __esDecorate(_classThis, null, _padDecimalZeros_decorators, { kind: "accessor", name: "padDecimalZeros", static: false, private: false, access: { has: obj => "padDecimalZeros" in obj, get: obj => obj.padDecimalZeros, set: (obj, value) => { obj.padDecimalZeros = value; } }, metadata: _metadata }, _padDecimalZeros_initializers, _padDecimalZeros_extraInitializers);
        __esDecorate(_classThis, null, _decimalSeparator_decorators, { kind: "accessor", name: "decimalSeparator", static: false, private: false, access: { has: obj => "decimalSeparator" in obj, get: obj => obj.decimalSeparator, set: (obj, value) => { obj.decimalSeparator = value; } }, metadata: _metadata }, _decimalSeparator_initializers, _decimalSeparator_extraInitializers);
        __esDecorate(_classThis, null, _thousandsSeparator_decorators, { kind: "accessor", name: "thousandsSeparator", static: false, private: false, access: { has: obj => "thousandsSeparator" in obj, get: obj => obj.thousandsSeparator, set: (obj, value) => { obj.thousandsSeparator = value; } }, metadata: _metadata }, _thousandsSeparator_initializers, _thousandsSeparator_extraInitializers);
        __esDecorate(_classThis, null, _min_decorators, { kind: "accessor", name: "min", static: false, private: false, access: { has: obj => "min" in obj, get: obj => obj.min, set: (obj, value) => { obj.min = value; } }, metadata: _metadata }, _min_initializers, _min_extraInitializers);
        __esDecorate(_classThis, null, _max_decorators, { kind: "accessor", name: "max", static: false, private: false, access: { has: obj => "max" in obj, get: obj => obj.max, set: (obj, value) => { obj.max = value; } }, metadata: _metadata }, _max_initializers, _max_extraInitializers);
        __esDecorate(_classThis, null, _step_decorators, { kind: "accessor", name: "step", static: false, private: false, access: { has: obj => "step" in obj, get: obj => obj.step, set: (obj, value) => { obj.step = value; } }, metadata: _metadata }, _step_initializers, _step_extraInitializers);
        __esDecorate(_classThis, null, _stepper_decorators, { kind: "accessor", name: "stepper", static: false, private: false, access: { has: obj => "stepper" in obj, get: obj => obj.stepper, set: (obj, value) => { obj.stepper = value; } }, metadata: _metadata }, _stepper_initializers, _stepper_extraInitializers);
        __esDecorate(_classThis, null, _precision_decorators, { kind: "accessor", name: "precision", static: false, private: false, access: { has: obj => "precision" in obj, get: obj => obj.precision, set: (obj, value) => { obj.precision = value; } }, metadata: _metadata }, _precision_initializers, _precision_extraInitializers);
        __esDecorate(_classThis, null, _maxDigitCount_decorators, { kind: "accessor", name: "maxDigitCount", static: false, private: false, access: { has: obj => "maxDigitCount" in obj, get: obj => obj.maxDigitCount, set: (obj, value) => { obj.maxDigitCount = value; } }, metadata: _metadata }, _maxDigitCount_initializers, _maxDigitCount_extraInitializers);
        __esDecorate(_classThis, null, __input_decorators, { kind: "accessor", name: "_input", static: false, private: false, access: { has: obj => "_input" in obj, get: obj => obj._input, set: (obj, value) => { obj._input = value; } }, metadata: _metadata }, __input_initializers, __input_extraInitializers);
        __esDecorate(_classThis, null, _set_disabledIncrease_decorators, { kind: "setter", name: "disabledIncrease", static: false, private: false, access: { has: obj => "disabledIncrease" in obj, set: (obj, value) => { obj.disabledIncrease = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _set_disabledDecrease_decorators, { kind: "setter", name: "disabledDecrease", static: false, private: false, access: { has: obj => "disabledDecrease" in obj, set: (obj, value) => { obj.disabledDecrease = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsNumberInput = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsNumberInput = _classThis;
})();
export { SdsNumberInput };
